var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("iframe", {
      staticClass: "responsive-iframe",
      attrs: { src: _vm.frameUrl, id: "frame-" + _vm.frameId }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }